<template>
  <div class="content">
    <div class="cardContent">
      <div class="kxq">
        <div class="rowClass">
          <p>
            <span class="span-l">ICCID:</span><span class="span-r">{{cardData.iccid}}</span>
          </p>
          <p>
            <span class="span-l">MSISDN:</span><span class="span-r">{{cardData.msisdn}}</span>
          </p>
          <p>
            <span class="span-l">{{ $t('app.cardDetail.agent') }}:</span><span class="span-r">{{cardData.company}}</span>
          </p>
          <p>
            <span class="span-l">{{cardData.name}}:</span>
            <span class="span-r span-refresh">{{cardData.cardStatus}}</span>
            <span class="span-refresh-btn"> <i class="el-icon-refresh" v-hasPermi="['card:info:refreshCardStatus']" @click="refreshCardStatus"></i></span>
          </p>
          <p>
            <span class="span-l">{{ $t('app.cardDetail.status') }}:</span><span class="span-r">{{cardData.showStatus}}</span>
          </p>
          <p v-if="adminShow">
            <span class="span-l">{{ $t('app.cardDetail.imei') }}:</span>
            <span class="span-r span-refresh">{{cardData.imei}}</span>
            <span class="span-refresh-btn"> <i class="el-icon-refresh" v-hasPermi="['card:info:refreshImei']" @click="refreshImei"></i></span>
          </p>
          
          <p>
            <span class="span-l">{{ $t('app.cardDetail.operator') }}:</span>
            <span class="span-r">{{cardData.operationName}}</span>
          </p>
          <p v-if="adminShow && checkPermi(['card:list:channel'])">
            <span class="span-l">{{ $t('app.cardDetail.cardSource') }}:</span><span class="span-r">{{cardData.cardSourceName}}</span>
          </p>
          <p v-if="adminShow">
            <span class="span-l">{{ $t('app.cardDetail.isLocked') }}:</span>
            <span class="span-r span-refresh">{{cardLock}}</span>
            <span class="span-refresh-btn"> <i class="el-icon-refresh" v-hasPermi="['card:info:refreshCardLock']"   @click="refreshCardLock"></i></span>
            <span class="span-lock-unlock"> <i class="el-icon-unlock" v-hasPermi="['card:info:unLockCard']" @click="unLockCard"></i></span>
          </p>
          <p v-if="adminShow">
            <span class="span-l">GPRS:</span>
            <span class="span-r span-refresh">{{cardData.gprsStatus}}</span>
            <span class="span-refresh-btn"> <i class="el-icon-refresh" v-hasPermi="['card:info:refreshGprsStatus']" @click="refreshGprsStatus"></i></span>
          </p>
          <p>
            <span class="span-l">{{ $t('app.cardDetail.monthlyFlow') }}:</span>
            <span class="span-r span-refresh">{{cardData.monthFlow}}</span>
            <span class="span-refresh-btn"> <i class="el-icon-refresh" v-hasPermi="['card:info:refreshMonthFlow']" @click="refreshMonthFlow"></i></span>
          </p>
          
          <p>
            <span class="span-l">{{ $t('app.cardDetail.syncStatus') }}:</span><span class="span-r">{{cardData.sync}}</span>
          </p>
          <p v-if="adminShow">
            <span class="span-l">{{ $t('app.cardDetail.realNameStatus') }}:</span><span class="span-r">{{cardData.kycStatus}}</span>
          </p>
          <p v-if="adminShow">
            <span class="span-l">{{ $t('app.cardDetail.onlineStatus') }}:</span>
            <span class="span-r span-refresh">{{cardData.online}}</span>
            <span class="span-refresh-btn"> <i class="el-icon-refresh" v-hasPermi="['card:info:refreshOnline']" @click="refreshOnline"></i></span>
          </p>
          <p v-if="adminShow">
            <span class="span-l">{{ $t('app.cardDetail.phoneNumber') }}:</span>
            <span class="span-r">{{cardData.phone}}
              <span v-hasPermi="['card:info:removePhone']" style="position: relative;top: -5px;cursor: pointer;" v-if="cardData.phone != '无'">
                <i class="el-icon-edit bianji-class" @click="resetPhone"></i>
              </span>
            </span>
          </p>
          <p v-if="adminShow">
            <span class="span-l">{{ $t('app.cardDetail.speedLimitStatus') }}:</span><span class="span-r">{{cardData.speedStatus}}</span>
          </p>
          <template v-if="adminShow">
            <p>
              <span class="span-l">{{ $t('app.cardDetail.statusSyncTime') }}:</span><span class="span-r">{{cardData.syncStatusTime}}</span>
            </p>
            <p>
              <span class="span-l">{{ $t('app.cardDetail.flowSyncTime') }}:</span><span class="span-r">{{cardData.syncTime}}</span>
            </p>
          </template>
          <template v-else>
            <p>
              <span class="span-l">{{ $t('app.cardDetail.syncTime') }}:</span><span class="span-r">{{cardData.syncTime}}</span>
            </p>
          </template>
          <p v-if="adminShow">
            <span class="span-l">{{ $t('app.cardDetail.openAccountTime') }}:</span><span class="span-r">{{cardData.openTime}}</span>
          </p>
          <p v-if="adminShow">
            <span class="span-l">{{ $t('app.cardDetail.allocationTime') }}:</span><span class="span-r">{{cardData.lastAdminTransferTime}}</span>
          </p>
          <p v-if="adminShow">
            <span class="span-l">{{ $t('app.cardDetail.closeAccountTime') }}:</span><span class="span-r">{{cardData.delTime}}</span>
          </p>
          <p>
            <span class="span-l">{{ $t('app.cardDetail.packageActiveTime') }}:</span><span class="span-r">{{cardData.activeTime}}</span>
          </p>
          <p>
            <span class="span-l">{{ $t('app.cardDetail.packageExpireTime') }}:</span><span class="span-r">{{cardData.expireTime}}</span>
          </p>
          <p v-if="adminShow">
            <span class="span-l">{{ $t('app.cardDetail.autoRenewal') }}:</span><span class="span-r">{{cardData.hasAgreement}}</span>
          </p>
          <p v-if="adminShow">
            <span class="span-l">{{ $t('app.cardDetail.cardExpireTime') }}:</span><span class="span-r">{{cardData.realExpireTime}}</span>
          </p>
          <p v-if="adminShow">
            <span class="span-l">{{ $t('app.cardDetail.cardOrientation') }}:</span><span class="span-r">{{cardData.orientations}}</span>
          </p>
          <p v-if="adminShow">
            <span class="span-l">{{ $t('app.cardDetail.integral') }}:</span><span class="span-r">{{cardData.integral}}</span>
          </p>
          <p v-if="adminShow">
            <span class="span-l">标签:
              <el-tooltip class="item" effect="dark" placement="top">
                <i class="el-icon-question" style="font-size: 14px; vertical-align: middle;"></i>
                <div slot="content">标签表示此卡是否机卡分离或者运营商管控等其他原因造成的卡无法开关机，管控后此卡不再停开机操作，除非点击重置按钮</div>
              </el-tooltip>
            </span>
            <span class="span-r  span-refresh">{{cardData.label}}</span>
            <span v-if="cardData.label !='运营商未管控'" class="span-refresh-btn"> <i class="el-icon-error" @click="resetLabel"></i></span>
          </p>
          <p v-if="adminShow">
            <span class="span-l">单卡限速值:</span><span class="span-r">{{cardData.speedLimitValue == 0?'不限制':cardData.speedLimitDescription}}</span>
          </p>
          <p v-if="adminShow">
            <span class="span-l">卡限制国家:</span><span class="span-r">{{cardData.enableCountryLimit ==0?'不限制':'已限制'}}<i v-if="cardData.enableCountryLimit ==1" style="margin-left:8px" class="el-icon-view" @click="cardCountries(cardData.iccid)"></i></span>
          </p>
        </div>
        <div class="poolClass" v-if="cardData.mode == 1">
          <p>
            <span class="span-l">{{ $t('app.cardDetail.poolName') }}:</span><span class="span-r">{{cardData.poolName}}</span>
          </p>
          <p>
            <span class="span-l">{{ $t('app.cardDetail.poolPeak') }}:</span><span class="span-r">{{cardData.poolLimit}}</span>
          </p>
          <p>
            <span class="span-l">{{ $t('app.cardDetail.poolMode') }}:</span><span class="span-r">{{cardData.poolType}}</span>
          </p>
          <p>
            <span class="span-l">{{ $t('app.cardDetail.poolCreateTime') }}:</span><span class="span-r">{{cardData.poolStartTime}}</span>
          </p>
          <p>
            <span class="span-l">{{ $t('app.cardDetail.poolExpireTime') }}:</span><span class="span-r">{{cardData.poolEndTime}}</span>
          </p>
        </div>
        <div class="aloneClass">
          <p v-if="adminShow && checkPermi(['card:info:agentLevel'])"><span class="span-l">{{ $t('app.cardDetail.levelDisplay') }}：</span><span class="span-r">{{cardData.companyNameLevel}}</span></p>
          <p>
            <span class="span-l">{{ $t('app.cardDetail.remarkDisplay') }}：</span>
            <span class="span-r">{{cardData.remark}}
              <span style="position: relative;top: -5px;cursor: pointer;" v-if="adminShow">
                <i class="el-icon-edit bianji-class" @click="editRow()"></i>
              </span>
            </span>
          </p>
          <p v-if="!adminShow">
            <el-button type="success" size="medium" v-hasPermi="['card:info:refresh']"  @click="refreshNow()">{{ $t('app.cardDetail.refreshNow') }}</el-button>
          </p>
        </div>
        <div class="operation-class">
          <el-button type="primary" size="medium" v-if="adminShow"  v-hasPermi="['card:info:sync']" class="anniu" @click="synchro()">{{this.cardData.sync == "已开启" ? $t('app.cardDetail.operation.closeSync'):$t('app.cardDetail.operation.openSync')}}</el-button>
          <el-button type="success" size="medium" v-hasPermi="['card:info:refresh']"  @click="updateNow()" v-if="adminShow">{{ $t('app.cardDetail.operation.immediateUpdate') }}</el-button>
          <!-- 管理员和代理商区别对待 -->
          <el-button type="danger" v-if="!adminShow"  size="medium" v-hasPermi="['card:info:openStopCard']"  @click="switchMachine(cardData.showStatus == '已激活' ? 5 : 4)">{{cardData.showStatus == "已激活" ? $t('app.cardDetail.operation.shutdown'):$t('app.cardDetail.operation.startup')}}</el-button>
          <el-button type="danger" v-if="adminShow && cardData.cardStatus!='预销户' && cardData.cardStatus!='已销户'"  size="medium" v-hasPermi="['card:info:openStopCard']"  @click="switchMachine(cardData.cardStatus == '已激活' ? 5 : 4)">{{cardData.cardStatus == "已激活" ? $t('app.cardDetail.operation.operationShutdown'):$t('app.cardDetail.operation.operationStartup')}}</el-button>
          
          <el-button type="warning" size="medium" v-hasPermi="['card:info:openStopGPRS']"  @click="switchGprs()">{{this.cardData.gprsStatus == "已开启" ? $t('app.cardDetail.operation.closeGprs') : $t('app.cardDetail.operation.openGprs')}}</el-button>
          <el-button type="info" size="medium" v-hasPermi="['card:info:openStopSpeedLimit']" v-if='this.cardData.speedStatus == "已限速"' @click="switchSpeedLimit()">{{this.cardData.speedStatus == "未限速" ? $t('app.cardDetail.operation.enableSpeedLimit') : $t('app.cardDetail.operation.disableSpeedLimit')}}</el-button>
          <el-button size="medium" v-hasPermi="['card:info:openStopShowStatus']" @click="falseStatusButton()" style="background:#99CCCC;border: 1px solid #99CCCC;color:#fff">{{this.cardData.showStatus == "已激活" ? $t('app.cardDetail.operation.statusOff') : $t('app.cardDetail.operation.statusOn')}}</el-button>
          <el-button type="info" size="medium" v-hasPermi="['card:info:diagnosticResults']" @click="refreshDiagnosticResults()" >一键诊断</el-button>
          <el-button type="info" v-if="cardData.channel=='DgMobile' || cardData.channel=='DgMobileAgent'" size="medium" v-hasPermi="['card:info:refreshStopRestartStatus']" @click="handleRefreshStopRestartStatus" >冻结查询</el-button>
        </div>
      </div>
    </div>
    <div class="cardContent marge-class">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane key="second" :label="$t('app.cardDetail.tabs.trafficPackageList')" name="second"  v-if="checkPermi(['card:info:cardProduct'])">
          <cardJftc  ref="cardJftcRef" :iccid="iccid" :labelTip="cardData.tips"></cardJftc>
        </el-tab-pane>
        <el-tab-pane key="smsProduct" :label="$t('app.cardDetail.tabs.smsPackageList')" name="smsProduct" v-if="checkPermi(['card:info:cardSmsProduct'])">
          <cardSmsProduct ref="cardSmsProduct" :iccid="iccid"></cardSmsProduct>
        </el-tab-pane>
        <el-tab-pane key="third" :label="$t('app.cardDetail.tabs.orderList')" name="third" v-if="checkPermi(['card:info:orderList'])">
          <cardOrderList ref="cardOrderListRef" :iccid="iccid"></cardOrderList>
        </el-tab-pane>
        <el-tab-pane key="fourth" :label="$t('app.cardDetail.tabs.operationList')" name="fourth" v-if="checkPermi(['card:info:operationList'])">
          <operationList ref="operationListRef" :iccid="iccid"></operationList>
        </el-tab-pane>
        <el-tab-pane key="fifth" :label="$t('app.cardDetail.tabs.remarkList')" name="fifth" v-if="checkPermi(['card:info:remarkList'])">
          <remarkList ref="remarkListRef" :iccid="iccid"></remarkList>
        </el-tab-pane>
        <el-tab-pane key="eighth" :label="$t('app.cardDetail.tabs.integralList')" name="eighth" v-if="checkPermi(['card:info:integralList'])">
          <cardIntegralList ref="cardIntegralListRef" :iccid="iccid"></cardIntegralList>
        </el-tab-pane>
        <el-tab-pane key="sixth" :label="$t('app.cardDetail.tabs.monthlyTrafficQuery')" name="sixth"  v-if="checkPermi(['card:info:monthFlow'])">
          <cardMonthDetail ref="cardFlowMonthRef"  :iccid ="iccid"></cardMonthDetail>
        </el-tab-pane>
        <el-tab-pane key="seventh" :label="$t('app.cardDetail.tabs.dailyTrafficQuery')" name="seventh"  v-if="checkPermi(['card:info:dayFlow'])">
          <cardDayDetail ref="cardFlowDayRef" :iccid ="iccid"></cardDayDetail>
        </el-tab-pane>
        <el-tab-pane key="ninth" :label="$t('app.cardDetail.tabs.diagnosticResults')" name="ninth" :lazy = "true" v-if="checkPermi(['card:info:diagnosticResults'])">
          <diagnosticResults ref="diagnosticResultsRef" :iccid ="iccid"></diagnosticResults>
        </el-tab-pane>

      </el-tabs>
    </div>
    <el-dialog title="备注" :visible.sync="dialog" @close="dialogClose" :lock-scroll="false" width="650px" v-dialogDrag :close-on-click-modal="false">
      <el-form :model="beizhu" ref="beizhu">
        <el-form-item label="备注内容:" prop="remark" label-width="100px">
          <el-input v-model="beizhu.remark" autocomplete="off" style="width: 80%" placeholder="请输入备注内容"></el-input>
        </el-form-item>
        <el-form-item label="售后内容:" prop="saleRemark" label-width="100px">
          <el-input type="textarea" v-model="beizhu.saleRemark" autocomplete="off" style="width: 80%" placeholder="请输入售后内容"></el-input>
        </el-form-item>
      </el-form>
      <div class="dialog-footer" slot="footer">
        <el-button type="primary" @click="cancelDialog">取消</el-button>
        <el-button type="success" @click="saveDialog">确认</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="限制使用国家"
      :visible.sync="dialogCountry"
      width="50%">
      <el-tag style="margin-right:10px;margin-bottom:10px;" v-for="(item,index) in countries" :key="index">{{item}}</el-tag>
    </el-dialog>
  </div>
</template>
<script>
import cardJftc from "@/components/cardDetails/cardJftc.vue";
import cardOrderList from "@/components/cardDetails/cardOrderList.vue";
import operationList from "@/components/cardDetails/operationList.vue";
import remarkList from "@/components/cardDetails/remarkList.vue";
import cardMonthDetail from "@/components/cardDetails/cardMonthDetail.vue";
import cardDayDetail from "@/components/cardDetails/cardDayDetail.vue";
import cardIntegralList from "@/components/cardDetails/cardIntegralList.vue";
import cardSmsProduct from "@/components/cardDetails/cardSmsProduct.vue";
import diagnosticResults from "@/components/cardDetails/diagnosticResults.vue";

import {
  cardDetail,
  syncRefreshCardStatus,
  syncRefreshGprsStatus,
  syncRefreshImei,
  syncRefreshMonthFlow,
  syncRefreshOnline,
  refreshStopRestartStatus
} from "@/api/api.js"; //卡详情的初始化数据
import { cleanPhone } from "@/api/api.js";//重置手机号
import { changeCardSyncStatus } from "@/api/api.js";//修改同步状态
import { syncCard } from "@/api/api.js";//立即更新
import { syncCardFlow } from "@/api/api.js";//立即更新
import { changeCardStatus } from "@/api/api.js";//开关机
import { changeCardNetStatus } from "@/api/api.js";//开关gprs
import { changeCardSpeedStatus } from "@/api/api.js";//开启关闭限速
import { saveRemark } from "@/api/api.js"; //流量卡备注
import { changeCardShowStatus } from "@/api/api.js"; //修改假状态
import { refreshCardLock } from "@/api/api.js"; //锁卡检测
import { unLockCard , resetCardLabel , cardCountries} from "@/api/api.js"; //锁卡检测
export default {
  data() {
    return {
      iccid : undefined,
      activeName: "second",
      cardLock:"未知",
      cardData:{},
      dialog:false,
      beizhu:{
        remark:"",
        saleRemark:""
      },
      dialogCountry:false,
      countries:[]
    };
  },
  computed: {
    adminShow(){
      return this.$store.getters.user.userType =='1'
    }
  },
  components: {
    cardJftc,
    cardOrderList,
    operationList,
    remarkList,
    cardMonthDetail,
    cardDayDetail,
    cardIntegralList,
    cardSmsProduct,
    diagnosticResults
  },
  methods: {
    handleClick(tab) {
      if (tab.name == "second") {
        this.$refs.cardJftcRef.initData();
      }else if(tab.name == "third"){
        this.$refs.cardOrderListRef.initData();
      }else if(tab.name == "fourth"){
        this.$refs.operationListRef.initData();
      }else if(tab.name == "fifth"){
        this.$refs.remarkListRef.initData();
      }else if(tab.name == "eighth"){
        this.$refs.cardIntegralListRef.initData();
      }else if(tab.name == "sixth"){
        this.$refs.cardFlowMonthRef.initChart()
      }else if(tab.name == "seventh"){
        this.$refs.cardFlowDayRef.initChart()
      }else if(tab.name == "smsProduct"){
        this.$refs.cardSmsProduct.initData();
      }else if(tab.name == "ninth"){
        this.$refs.diagnosticResultsRef.initData();
      }
    },
    transferFlowRatio(status) {
      let obj = {
        1: "库存",
        2: "待激活",
        3: "可测试",
        4: "已激活",
        5: "已停机",
        6: "预销户",
        7: "已销户",
        8: "停机保号",
        9: "已补卡",
      };
      return obj[status];
    },
    Realnamestatus(status) {
      let obj = {
        0: "未实名 ",
        1: "实名中",
        2: "已实名",
        3: "未通过",
        4: "已注销",
      };
      return obj[status];
    },
    // 初始化数据
    initData() {
      let params ={
        iccid : this.iccid
      }
      cardDetail(params).then(res => {
        if(res.data.code == 200){
          this.cardData = res.data.data;
          this.cardData.kycStatus = this.Realnamestatus(this.cardData.kycStatus);
          this.cardData.sync = this.cardData.sync == "开启" ? "已开启" : "未开启";
          this.cardData.gprsStatus = this.cardData.gprsStatus == "开启" ? "已开启" : "未开启";
          this.cardData.speedStatus = this.cardData.speedStatus == 0 ? "未限速" : "已限速";
          this.cardData.monthFlow = this.cardData.monthFlow == null ? "无" : this.cardData.monthFlow + "M";
          this.cardData.remark = this.cardData.remark == null || this.cardData.remark == "" ? "无" : this.cardData.remark;
          this.cardData.openTime = this.cardData.openTime == null ? "无" : this.cardData.openTime;
          this.cardData.lastAdminTransferTime = this.cardData.lastAdminTransferTime == null ? "无" : this.cardData.lastAdminTransferTime;
          this.cardData.delTime = this.cardData.delTime == null ? "无" : this.cardData.delTime;
          this.cardData.activeTime = this.cardData.activeTime == null ? "无" : this.cardData.activeTime;
          this.cardData.expireTime = this.cardData.expireTime == null ? "无" : this.cardData.expireTime;
          this.cardData.realExpireTime = this.cardData.realExpireTime == null ? "无" : this.cardData.realExpireTime;
          this.cardData.phone = this.cardData.phone == null || this.cardData.phone == "" ? "无" : this.cardData.phone;
          this.cardData.company = this.cardData.company == null ? "未分配" : this.cardData.company;
          this.cardData.companyNameLevel = this.cardData.companyNameLevel == null ? "未分配" : this.cardData.companyNameLevel;
          this.cardData.imei = this.cardData.imei == null ? "无" : this.cardData.imei;
          this.cardData.hasAgreement = this.cardData.hasAgreement == 0 ? "未签约" : "已签约";
          this.cardData.orientations = this.cardData.orientations ? this.cardData.orientations.toString().replaceAll(",","\n"):"";
          switch (this.cardData.online) {
            case "online":
              this.cardData.online = "在线";
              break;
            case "offline":
              this.cardData.online = "不在线";
              break;
            case "unknown":
              this.cardData.online = "未查询到会话信息";
              break;
            case null:
              this.cardData.online = "未查询";
              break;
          }
          if (this.cardData.cardLock == "unknown") {
            this.cardLock = "未知";
          }
          if (this.cardData.cardLock == "lock") {
            this.cardLock = "锁卡";
          }
          if (this.cardData.cardLock == "unlock") {
            this.cardLock = "未锁卡";
          }
          // 运营状态--运营商状态真的
          // 状态--公众号展示状态假的
          if(this.adminShow){
            this.cardData.name = '运营状态';
            this.cardData.cardStatus = this.transferFlowRatio(this.cardData.cardStatus);
            this.cardData.showStatus = this.transferFlowRatio(this.cardData.showStatus);
          }else{
            this.cardData.showStatus = this.transferFlowRatio(this.cardData.showStatus);
            this.cardData.name = 'IMSI';
            this.cardData.cardStatus = "无";
            this.cardData.cardSourceName = "无";
            this.cardData.gprsStatus = "已开启";
            if(this.cardData.hasEnjoy == "1"){
              this.cardData.monthFlow = "畅享"
            }
          };
        }
      })
    },
    // 重置手机号
    resetPhone(){
       this.$confirm('是否继续重置手机号?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let params = {
          iccid : this.iccid
        }
        cleanPhone(params).then(res => {
          this.$message({
              type: 'success',
              message: '重置成功!'
            });
          this.initData()
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消重置'
        });          
      });
    },
    // 开关同步
    synchro(){
      let params = {
        iccid:this.iccid
      };
      if(this.cardData.sync == "已开启"){
        params.syncStatus = 0;
        changeCardSyncStatus(params).then(res =>{
          if (res.data.code == 200) {
            this.$message.success("关闭同步成功");
            this.initData();
          } else {
            this.$message.error(res.data.message);
          }
        })
      }else{
        params.syncStatus = 1;
        changeCardSyncStatus(params).then(res =>{
          if (res.data.code == 200) {
            this.$message.success("开启同步成功");
            this.initData();
          } else {
            this.$message.error(res.data.message);
          }
        })
      }
    },
    // 立即更新
    updateNow(){
      let params = {
        iccid:this.iccid
      }
      syncCard(params).then(res =>{
        if (res.data.code == 200) {
          this.$message.success("立即更新成功");
          this.initData();
        } else {
          this.$message.error(res.data.message);
        }
      })
    },
    //开关机
    switchMachine(status){
      let params = {
        iccid : this.iccid
      }
      if(status == 4){
        params.cardStatus = 4;
        changeCardStatus(params).then(res =>{
          this.$message({
              message: res.data.message,
              type: 'success'
            });
          this.initData();
        })
      }else{
        params.cardStatus = 5;
        changeCardStatus(params).then(res =>{
            this.$message({
              message: res.data.message,
              type: 'success'
            });
            this.initData();
        })
      }
    },
    // 开关gprs
    switchGprs(){
      let params ={
        iccid:this.iccid
      }
      if(this.cardData.gprsStatus == "已开启"){
        params.netStatus = 0;
        changeCardNetStatus(params).then(res =>{
          if (res.data.code == 200) {
            this.$message.success("关闭GPRS成功");
            this.initData();
          } else {
            this.$message.error(res.data.message);
          }
        })
      }else{
        params.netStatus = 1;
        changeCardNetStatus(params).then(res =>{
          if (res.data.code == 200) {
            this.$message.success("开启GPRS成功");
            this.initData();
          } else {
            this.$message.error(res.data.message);
          }
        })
      }
    },
    // 开关限速
    switchSpeedLimit(){
      let params ={
        iccid:this.iccid
      }
      if(this.cardData.speedStatus == "未限速"){
        params.speedStatus = 1;
        changeCardSpeedStatus(params).then(res =>{
          if (res.data.code == 200) {
            this.$message.success("开启限速成功");
            this.initData();
          } else {
            this.$message.error(res.data.message);
          }
        })
      }else{
        params.speedStatus = 0;
        changeCardSpeedStatus(params).then(res =>{
          if (res.data.code == 200) {
            this.$message.success("关闭限速成功");
            this.initData();
          } else {
            this.$message.error(res.data.message);
          }
        })
      }
    },
    // 立即刷新
    refreshNow(){
      let params ={
        iccid:this.iccid
      }
      syncCardFlow(params).then(res =>{
        if (res.data.code == 200) {
          this.$message.success("立即刷新成功");
          this.initData();
        } else {
          this.$message.error(res.data.message);
        }
      })
    },
    // 更改假状态按钮
    falseStatusButton(){
      let params = {
        iccid:this.iccid
      }
      if(this.cardData.showStatus == "已激活"){
        params.showStatus = 5;
        changeCardShowStatus(params).then(res=>{
          if (res.data.code == 200) {
            this.$message.success("更改状态成功");
            this.initData();
          } else {
            this.$message.error(res.data.message);
          }
        })
      }else{
        params.showStatus = 4;
        changeCardShowStatus(params).then(res=>{
          if (res.data.code == 200) {
            this.$message.success("更改状态成功");
            this.initData();
          } else {
            this.$message.error(res.data.message);
          }
        })
      }
    },
    // 备注的弹窗
    editRow(){
      this.dialog = true;
      this.beizhu ={};
      this.$set(this.beizhu,"remark",this.cardData.remark)
    },
    // 备注弹窗x
    dialogClose(){
      this.$refs.beizhu.clearValidate();
      this.dialog = false;
    },
    // 备注的取消按钮
    cancelDialog(){
      this.dialog = false;
    },
    // 备注的确认按钮
    saveDialog(){
      let params = {
        iccid:this.cardData.iccid,
        remark:this.beizhu.remark,
        saleRemark:this.beizhu.saleRemark
      };
      saveRemark(params).then(res =>{
        if (res.data.code == 200) {
          this.$message.success("备注成功");
          this.dialog = false;
          this.beizhu = {};
          this.initData();
        }
      })
    },
    //锁卡监测
    refreshCardLock() {
      let imei = this.cardData.imei;
      if (!!imei) {
        let params = {
          iccid: this.cardData.iccid,
        };
        refreshCardLock(params).then((res) => {
          this.$message({
              message: "锁卡查询成功",
              type: "success",
          });
          let result = res.data;
          if (result.data == "unknown") {
            this.cardLock = "未知";
          }
          if (result.data == "lock") {
            this.cardLock = "锁卡";
          }
          if (result.data == "unlock") {
            this.cardLock = "未锁卡";
          }
        });
      } else {
        this.$message({
          message: "IMEI不能为空",
          type: "warning",
        });
      }
    },
    //解绑
    unLockCard() {
      let params = {
        iccid: this.cardData.iccid,
      };
     this.$confirm('此操作将重置绑定的设备, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          unLockCard(params).then((res) => {
            let result = res.data;
            this.$message({
                message: "机卡重绑成功",
                type: "success",
            });
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消机卡重绑'
          });          
        }); 
    },
    //刷新运营状态
    refreshCardStatus() {
      let params = {
        iccid: this.cardData.iccid,
      };
      syncRefreshCardStatus(params).then((res) => {
          this.$message.success(res.data.message);
          this.initData();
      });
    },
    //刷新IMEI
    refreshImei() {
      let params = {
        iccid: this.cardData.iccid,
      };
      syncRefreshImei(params).then((res) => {
        this.$message.success(res.data.message);
        this.initData();
      });
    },
    //刷新GPRS
    refreshGprsStatus() {
      let params = {
        iccid: this.cardData.iccid,
      };
      syncRefreshGprsStatus(params).then((res) => {
        this.$message.success(res.data.message);
        this.initData();
      });
    },
    //刷新当月流量
    refreshMonthFlow() {
      let params = {
        iccid: this.cardData.iccid,
      };
      syncRefreshMonthFlow(params).then((res) => {
        this.$message.success(res.data.message);
        this.initData();
      });
    },
    //刷新在线状态
    refreshOnline() {
      let params = {
        iccid: this.cardData.iccid,
      };
      syncRefreshOnline(params).then((res) => {
        this.$message.success(res.data.message);
        this.initData();
      });
    },
    //刷新诊断结果
    refreshDiagnosticResults(){
      this.activeName = "ninth"
      this.$refs.diagnosticResultsRef.refreshDiagnosticData()
    },
    handleRefreshStopRestartStatus(){
      let iccid = this.cardData.iccid
      refreshStopRestartStatus({iccid}).then(res=>{
        this.$message.success(res.data.message)
        this.initData()
      })
    },
    resetLabel(){
      let params = {
        iccid: this.cardData.iccid,
      };
     this.$confirm('此操作将重置卡标签为非管控, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          resetCardLabel(params).then((res) => {
            this.$message({
                message: "重置成功",
                type: "success",
            });
            this.initData()
          });
        }).catch(() => {
                  
        });
    },
    cardCountries(iccid){
      this.dialogCountry = true
      cardCountries({iccid}).then(res=>{
        this.countries = res.data.data
      })
    }
  },
  beforeRouteUpdate(to, from, next) {
    if(to.name == 'carddetail' && to.query && to.query.iccid){
      if (to.query.iccid === this.iccid) {
        return next();
      }
      this.iccid =  to.query && to.query.iccid;
      this.initData();
      // this.activeName = "second";
      // this.$refs.cardJftcRef.changeIccid(this.iccid);
      // this.$refs.cardJftcRef.initData();
    }
    next();
  },
  created() {
    this.iccid =  this.$route.query && this.$route.query.iccid;
    this.initData();
  },
  mounted() {
    if(!this.checkPermi(['card:info:cardProduct'])){
        this.activeName = 'smsProduct';
    } 
  },
};
</script>
<style scoped lang="less">
  .cardContent{
    padding: 0 20px;
  }
  .kxq{
    width: 100%;
    .rowClass{
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      p{
        width: 33.3%;
        padding: 8px 0;
      }
    }
    .poolClass{
      border: 1px solid #DCDFE6;
      border-left: none;
      border-right: none;
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      p{
        width: 33.3%;
        padding: 8px 0;
      }
    }
      .span-l{
        display: inline-block;
        width: 30%;
        text-align: left;
        font-size: 14px;
        color: #606266;
      }
      .span-r{
        display: inline-block;
        width: 70%;
        font-size: 14px;
        color: #1890ff;
      }
      .span-refresh{
        width: auto;
      }
      .span-refresh-btn{
        margin-left: 6px;
        font-size: 1.25rem;
        color: #67C23A;
      }
      .span-lock-unlock{
        font-size: 1.25rem;
        margin-left: 8px;
        color: #F56C6C;
      }
  }
  .aloneClass{
    p{
      padding: 8px 0;
    }
    .span-l{
      display: inline-block;
      width: 10%;
      text-align: left;
      font-size: 14px;
      color: #606266;
    }
    .span-r{
      display: inline-block;
      width: 90%;
      font-size: 14px;
      color: #1890ff;
    }
  }
  .operation-class{
    margin-top: 18px;
  }
  .marge-class{
    margin-top: 18px;
    padding-bottom:40px ;
  }
  @media screen and (max-width: 750px){
    .rowClass p{
      width: 100% !important;
    }
    .poolClass p{
      width: 100% !important;
    }
    .aloneClass p{
      .span-l{
        width: 30%;
      }
      .span-r{
        margin-left:10px
      }
    }
    .operation-class{
      .anniu{
        margin-left: 10px;
      }
      button{
        display: block;
        margin-top: 10px;
      }
    }
  }
  @media screen and (min-width: 750px) and (max-width: 1310px){
    .rowClass p{
      width: 50% !important;
    }
    .poolClass p{
      width: 50% !important;
    }
    .aloneClass p{
      .span-l{
        width: 15% !important;
      }
      .span-r{
        width:85% !important;
      }
    }
  }
</style>  